'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _objectWithoutPropertiesLoose = _interopDefault(require('@babel/runtime/helpers/objectWithoutPropertiesLoose'));
var React = require('react');
var React__default = _interopDefault(React);
var victory = require('victory');
var components = require('@engaging-tech/components');
var frontendUtils = require('@engaging-tech/frontend-utils');

var calculateProgress = function calculateProgress(percentage) {
  return [{
    x: "current",
    y: percentage
  }, {
    x: "remaining",
    y: 100 - percentage
  }];
};

var CircularProgress = function CircularProgress(_ref) {
  var percentage = _ref.percentage,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 400 : _ref$size,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "bold" : _ref$fontWeight,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? "rgba(0, 0, 0, 0.6)" : _ref$textColor,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? "rgba(0, 0, 0, 0.15)" : _ref$bgColor,
      labelText = _ref.labelText,
      _ref$labelSize = _ref.labelSize,
      labelSize = _ref$labelSize === void 0 ? 60 : _ref$labelSize,
      _ref$fontSizeNoLabel = _ref.fontSizeNoLabel,
      fontSizeNoLabel = _ref$fontSizeNoLabel === void 0 ? 80 : _ref$fontSizeNoLabel,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 0.41 : _ref$thickness,
      noData = _ref.noData,
      victoryProps = _ref.victoryProps,
      props = _objectWithoutPropertiesLoose(_ref, ["percentage", "size", "fontWeight", "textColor", "bgColor", "labelText", "labelSize", "fontSizeNoLabel", "thickness", "noData", "victoryProps"]);

  var strokeColor = props.strokeColor;

  var textToShow = function textToShow() {
    if (labelText && !noData) return percentage.toFixed(0) + "%\n" + labelText;
    if (!labelText && !noData) return percentage.toFixed(0) + "%";
    if (noData && labelText) return "" + labelText;
    if (noData) return "No Data";
    return percentage.toFixed(0) + "%";
  };

  return React__default.createElement(components.Box, props, React__default.createElement("svg", {
    viewBox: "0 0 " + size + " " + size,
    width: "100%",
    height: "100%"
  }, React__default.createElement(victory.VictoryPie, _extends({
    standalone: false,
    width: size,
    height: size,
    data: noData ? calculateProgress(0) : calculateProgress(percentage),
    innerRadius: size * thickness,
    labels: function labels() {
      return null;
    },
    style: {
      data: {
        fill: function fill(_ref2) {
          var datum = _ref2.datum;
          return datum.x === "current" ? strokeColor || "#000000" : bgColor;
        }
      }
    }
  }, victoryProps)), React__default.createElement(victory.VictoryLabel, {
    className: "chart-label",
    text: textToShow(),
    textAnchor: "middle",
    verticalAnchor: "middle",
    x: size / 2,
    y: size / 2,
    style: {
      fontSize: labelText ? labelSize : fontSizeNoLabel,
      fontWeight: fontWeight,
      fill: textColor,
      fontFamily:
      /* eslint-disable-next-line quotes */
      '"Roboto", "Gill Sans MT", "Ser­avek", "Trebuchet MS", sans-serif'
    }
  })));
};

var DEFAULT_COLOURS = {
  bar: ["rgba(169, 240, 213, 1)", "rgba(191, 169, 240, 1)", "rgba(169, 199, 240, 1)"],
  label: "rgba(0, 0, 0, 0.54)",
  axis: "rgba(0, 0, 0, 0.4)"
};

var PercentageBar = function PercentageBar(_ref) {
  var _style$xAxis, _style$xAxis2, _style$yAxis, _style$yAxis2, _style$bars, _style$bars2;

  var data = _ref.data,
      labels = _ref.labels,
      style = _ref.style,
      _ref$colours = _ref.colours,
      colours = _ref$colours === void 0 ? DEFAULT_COLOURS : _ref$colours;
  return React__default.createElement(victory.VictoryChart, {
    domain: {
      y: [0, 100]
    },
    domainPadding: {
      x: 100
    }
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: labels,
    style: _extends({
      axis: _extends({
        stroke: colours.axis
      }, style === null || style === void 0 ? void 0 : (_style$xAxis = style.xAxis) === null || _style$xAxis === void 0 ? void 0 : _style$xAxis.axis),
      tickLabels: _extends({
        fontSize: 10,
        fill: colours.label,
        padding: 0
      }, style === null || style === void 0 ? void 0 : (_style$xAxis2 = style.xAxis) === null || _style$xAxis2 === void 0 ? void 0 : _style$xAxis2.tickLabels)
    }, style === null || style === void 0 ? void 0 : style.xAxis)
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: [0, 100],
    tickFormat: function tickFormat(x) {
      return x.toFixed(0) + "%";
    },
    style: _extends({
      axis: _extends({
        stroke: colours.axis
      }, style === null || style === void 0 ? void 0 : (_style$yAxis = style.yAxis) === null || _style$yAxis === void 0 ? void 0 : _style$yAxis.axis),
      tickLabels: _extends({
        fontSize: 10,
        fill: colours.label,
        padding: 4
      }, style === null || style === void 0 ? void 0 : (_style$yAxis2 = style.yAxis) === null || _style$yAxis2 === void 0 ? void 0 : _style$yAxis2.tickLabels)
    }, style === null || style === void 0 ? void 0 : style.yAxis)
  }), React__default.createElement(victory.VictoryBar, {
    data: data,
    barRatio: 1,
    barWidth: 70,
    labels: function labels(_ref2) {
      var datum = _ref2.datum;
      return (datum.y ? datum.y.toFixed(0) : 0) + "%";
    },
    style: _extends({
      data: _extends({
        fill: function fill(_ref3) {
          var index = _ref3.index;
          return colours.bar[index] || colours.bar[0];
        }
      }, style === null || style === void 0 ? void 0 : (_style$bars = style.bars) === null || _style$bars === void 0 ? void 0 : _style$bars.data),
      labels: _extends({
        fill: colours.label,
        fontSize: 10,
        padding: -16
      }, style === null || style === void 0 ? void 0 : (_style$bars2 = style.bars) === null || _style$bars2 === void 0 ? void 0 : _style$bars2.labels)
    }, style === null || style === void 0 ? void 0 : style.bars)
  }));
};

var fontFamily
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Ser­avek", "Trebuchet MS", sans-serif';
var darkColors = ["rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)"];
var scatterDataStyles = {
  you: {
    fill: "rgba(169, 240, 213, 0.5)",
    stroke: "rgba(169, 240, 213, 1)",
    strokeWidth: 2
  },
  industry: {
    fill: "rgba(191, 169, 240, 0.5)",
    stroke: "rgba(191, 169, 240, 1)",
    strokeWidth: 2
  },
  global: {
    fill: "rgba(169, 199, 240, 0.5)",
    stroke: "rgba(169, 199, 240, 1)",
    strokeWidth: 2
  }
};
var styles = {
  tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  labels: {
    fontSize: 14,
    fill: darkColors[1],
    fontWeight: "bold",
    fontFamily: fontFamily
  },
  quadrantLabels: function quadrantLabels(matches) {
    return {
      fontSize: matches ? 16 : 18,
      fill: darkColors[1],
      fontFamily: fontFamily
    };
  },
  quadrantLabelsWithOverlay: function quadrantLabelsWithOverlay(matches) {
    return {
      title: {
        fontSize: matches ? 16 : 18,
        fontWeight: "bold",
        fill: "white",
        fontFamily: fontFamily
      },
      description: {
        fontSize: matches ? 14 : 16,
        fill: "white",
        fontFamily: fontFamily
      }
    };
  },
  scatterLabels: {
    fontSize: 14,
    fill: darkColors[0],
    fontFamily: fontFamily
  },
  axes: {
    grid: {
      stroke: function stroke(_ref) {
        var tick = _ref.tick;
        return tick === 50 ? darkColors[0] : "transparent";
      },
      // split grid into four quadrants
      strokeWidth: 1,
      backgroundColor: "black"
    },
    gridOverlay: {
      stroke: function stroke(_ref2) {
        var tick = _ref2.tick;
        return tick === 50 ? "white" : "transparent";
      },
      // split grid into four quadrants
      strokeWidth: 1,
      backgroundColor: "black"
    },
    tickLabels: {
      fontSize: 11,
      fill: darkColors[1],
      fontFamily: fontFamily
    },
    axis: {
      stroke: darkColors[1]
    }
  }
};

var determineYAxisLabelDisplacement = function determineYAxisLabelDisplacement(noOfYAxisLabels, yAxisHeading) {
  if (noOfYAxisLabels > 1 && !yAxisHeading) return 50;
  if (noOfYAxisLabels > 1 && yAxisHeading) return 63;
  if (noOfYAxisLabels === 1 && !yAxisHeading) return 55;
  return 58;
};

var determineXAxisLabelDisplacement = function determineXAxisLabelDisplacement(noOfXAxisLabels, xAxisHeading) {
  if (noOfXAxisLabels > 1 && !xAxisHeading) return 20;
  if (noOfXAxisLabels > 1 && xAxisHeading) return 11;
  if (noOfXAxisLabels === 1 && !xAxisHeading) return 30;
  return 24;
}; // Function to wrap text to next line of long labels


var formatMainLabels = function formatMainLabels(text, maxWidth) {
  return text.replace(new RegExp("(?![^\\n]{1," + maxWidth + "}$)([^\\n]{1," + maxWidth + "})\\s", "g"), "$1\n");
};

var ResultsMatrix = function ResultsMatrix(_ref3) {
  var _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 500 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 1000 : _ref3$width,
      xAxisLabels = _ref3.xAxisLabels,
      yAxisLabels = _ref3.yAxisLabels,
      data = _ref3.data,
      quadrantLabels = _ref3.quadrantLabels,
      overlay = _ref3.overlay,
      _ref3$youLabel = _ref3.youLabel,
      youLabel = _ref3$youLabel === void 0 ? "You" : _ref3$youLabel,
      _ref3$globalLabel = _ref3.globalLabel,
      globalLabel = _ref3$globalLabel === void 0 ? "Global" : _ref3$globalLabel,
      _ref3$industryLabel = _ref3.industryLabel,
      industryLabel = _ref3$industryLabel === void 0 ? "Industry" : _ref3$industryLabel;

  var _useState = React.useState(window.matchMedia("(min-width: 768px)").matches),
      matches = _useState[0],
      setMatches = _useState[1];

  var handler = function handler(e) {
    return setMatches(e.matches);
  };

  React.useEffect(function () {
    window.matchMedia("(min-width: 768px)").addListener(handler);
    return window.matchMedia("(min-width: 768px)").addListener(handler);
  });
  var noOfYAxisLabels = yAxisLabels && yAxisLabels.questions && yAxisLabels.questions.length;
  var noOfXAxisLabels = xAxisLabels && xAxisLabels.questions && xAxisLabels.questions.length;
  var xAxisLabel = xAxisLabels && xAxisLabels.questions && xAxisLabels.questions.join(" ");
  var yAxisLabel = yAxisLabels && yAxisLabels.questions && yAxisLabels.questions.join(" ");
  var xAxisHeading = xAxisLabels && xAxisLabels.heading;
  var yAxisHeading = yAxisLabels && yAxisLabels.heading;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domain: {
      x: [0, 100],
      y: [0, 100]
    },
    padding: {
      left: 90,
      bottom: 90,
      right: 27,
      top: 27
    },
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryScatter, {
    size: 30,
    data: [data.global],
    labels: [globalLabel],
    style: {
      data: scatterDataStyles.global,
      labels: styles.scatterLabels
    },
    labelComponent: React__default.createElement(victory.VictoryLabel, {
      dy: 5
    })
  }), React__default.createElement(victory.VictoryScatter, {
    size: 30,
    data: [data.industry],
    labels: [industryLabel],
    style: {
      data: scatterDataStyles.industry,
      labels: styles.scatterLabels
    },
    labelComponent: React__default.createElement(victory.VictoryLabel, {
      dy: 5
    })
  }), React__default.createElement(victory.VictoryScatter, {
    size: 30,
    data: [data.you],
    labels: [youLabel],
    style: {
      data: scatterDataStyles.you,
      labels: styles.scatterLabels
    },
    labelComponent: React__default.createElement(victory.VictoryLabel, {
      dy: 5
    })
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 + 45,
    y: height * 15 / 100 - 20,
    style: styles.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 * 3 + 25,
    y: height * 15 / 100 - 20,
    style: styles.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 + 45,
    y: height * 85 / 100 - 25,
    style: styles.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 * 3 + 25,
    y: height * 85 / 100 - 25,
    style: styles.quadrantLabels(matches)
  }), overlay && React__default.createElement(victory.VictoryArea, {
    style: {
      data: {
        fill: "rgba(0, 0, 0, 0.7)"
      }
    },
    data: [{
      x: 0,
      y: 100
    }, {
      x: 100,
      y: 100
    }]
  }), React__default.createElement(victory.VictoryAxis, {
    tickValues: styles.tickValues,
    tickFormat: styles.tickFormat,
    style: overlay ? _extends({}, styles.axes, {
      grid: styles.axes.gridOverlay
    }) : styles.axes,
    standalone: false
  }), !!xAxisHeading && React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(xAxisHeading, 100) || "",
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 2 + 35,
    y: height * 89 / 100,
    style: _extends({}, styles.labels, {
      fill: darkColors[0],
      fontSize: 15
    })
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(xAxisLabel || "", 100),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 2 + 35,
    y: height * 97 / 100 - determineXAxisLabelDisplacement(noOfXAxisLabels, xAxisHeading),
    style: styles.labels
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles.tickValues,
    tickFormat: styles.tickFormat,
    style: overlay ? _extends({}, styles.axes, {
      grid: styles.axes.gridOverlay
    }) : styles.axes,
    standalone: false
  }), !!yAxisHeading && React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(yAxisHeading, noOfYAxisLabels > 1 ? 60 : 50),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: noOfYAxisLabels > 1 ? 20 : 25,
    y: height / 2 - 30,
    style: _extends({}, styles.labels, {
      fill: darkColors[0],
      fontSize: 15
    }),
    angle: 270
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(yAxisLabel || "", noOfYAxisLabels > 1 ? 60 : 50),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: determineYAxisLabelDisplacement(noOfYAxisLabels, yAxisHeading),
    y: height / 2 - 30,
    style: styles.labels,
    angle: 270
  }), overlay && React__default.createElement(React__default.Fragment, null, React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 27 / 100 + 45,
    y: height * 20 / 100 - 20,
    style: styles.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(quadrantLabels.topLeft.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 27 / 100 + 45,
    y: height * 25 / 100 - 20,
    style: styles.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 73 / 100 + 20,
    y: height * 20 / 100 - 20,
    style: styles.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(quadrantLabels.topRight.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 73 / 100 + 20,
    y: height * 25 / 100 - 20,
    style: styles.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 27 / 100 + 45,
    y: height * 60 / 100 - 30,
    style: styles.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(quadrantLabels.bottomLeft.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 27 / 100 + 45,
    y: height * 65 / 100 - 30,
    style: styles.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 73 / 100 + 20,
    y: height * 60 / 100 - 30,
    style: styles.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels(quadrantLabels.bottomRight.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 73 / 100 + 20,
    y: height * 65 / 100 - 30,
    style: styles.quadrantLabelsWithOverlay(matches).description
  })));
};

var fontFamily$1
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Ser­avek", "Trebuchet MS", sans-serif';
var darkColors$1 = ["rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)"];
var scatterDataStyles$1 = {
  current: {
    fill: "rgba(255, 222, 195, 0.5)",
    stroke: "rgba(255, 152, 0, 1)",
    strokeWidth: 1
  },
  previous: {
    fill: "rgba(0, 225, 255, 0.1)",
    stroke: "rgba(0, 225, 255, 0.4)",
    strokeWidth: 1
  }
};
var styles$1 = {
  tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  labels: {
    fontSize: 14,
    fill: darkColors$1[1],
    fontWeight: "bold",
    fontFamily: fontFamily$1
  },
  quadrantLabels: function quadrantLabels(matches) {
    return {
      fontSize: matches ? 16 : 18,
      fill: darkColors$1[1],
      fontFamily: fontFamily$1
    };
  },
  quadrantLabelsWithOverlay: function quadrantLabelsWithOverlay(matches) {
    return {
      title: {
        fontSize: matches ? 14 : 18,
        fontWeight: "bold",
        fill: "white",
        fontFamily: fontFamily$1
      },
      description: {
        fontSize: matches ? 14 : 16,
        fill: "white",
        fontFamily: fontFamily$1
      }
    };
  },
  axes: {
    grid: {
      stroke: function stroke(_ref) {
        var tick = _ref.tick;
        return tick === 50 ? darkColors$1[0] : "transparent";
      },
      // split grid into four quadrants
      strokeWidth: 1,
      backgroundColor: "black"
    },
    gridOverlay: {
      stroke: function stroke(_ref2) {
        var tick = _ref2.tick;
        return tick === 50 ? "white" : "transparent";
      },
      // split grid into four quadrants
      strokeWidth: 1,
      backgroundColor: "black"
    },
    tickLabels: {
      fontSize: 11,
      fill: darkColors$1[1],
      fontFamily: fontFamily$1
    },
    axis: {
      stroke: darkColors$1[1]
    }
  }
}; // Function to wrap text to next line of long labels

var formatMainLabels$1 = function formatMainLabels(text, maxWidth) {
  return text.replace(new RegExp("(?![^\\n]{1," + maxWidth + "}$)([^\\n]{1," + maxWidth + "})\\s", "g"), "$1\n");
};

var determineYAxisLabelDisplacement$1 = function determineYAxisLabelDisplacement(noOfYAxisLabels, yAxisHeading) {
  if (noOfYAxisLabels > 1 && !yAxisHeading) return 50;
  if (noOfYAxisLabels > 1 && yAxisHeading) return 63;
  if (noOfYAxisLabels === 1 && !yAxisHeading) return 55;
  return 58;
};

var determineXAxisLabelDisplacement$1 = function determineXAxisLabelDisplacement(noOfXAxisLabels, xAxisHeading) {
  if (noOfXAxisLabels > 1 && !xAxisHeading) return 20;
  if (noOfXAxisLabels > 1 && xAxisHeading) return 11;
  if (noOfXAxisLabels === 1 && !xAxisHeading) return 30;
  return 24;
};

var HoverLabel = function HoverLabel(props) {
  return React__default.createElement(victory.VictoryTooltip, _extends({}, props, {
    orientation: "bottom",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    dy: 0,
    dx: 0,
    flyoutWidth: 150,
    flyoutHeight: 60,
    constrainToVisibleArea: true
  }));
};

HoverLabel.defaultEvents = victory.VictoryTooltip.defaultEvents;

var OrganisationMatrix = function OrganisationMatrix(_ref3) {
  var _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 500 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 1000 : _ref3$width,
      xAxisLabels = _ref3.xAxisLabels,
      yAxisLabels = _ref3.yAxisLabels,
      data = _ref3.data,
      quadrantLabels = _ref3.quadrantLabels,
      overlay = _ref3.overlay;

  var _useState = React.useState(window.matchMedia("(min-width: 768px)").matches),
      matches = _useState[0],
      setMatches = _useState[1];

  var handler = function handler(e) {
    return setMatches(e.matches);
  };

  React.useEffect(function () {
    window.matchMedia("(min-width: 768px)").addListener(handler);
    return window.matchMedia("(min-width: 768px)").addListener(handler);
  });
  var noOfYAxisLabels = yAxisLabels && yAxisLabels.questions && yAxisLabels.questions.length;
  var noOfXAxisLabels = xAxisLabels && xAxisLabels.questions && xAxisLabels.questions.length;
  var xAxisLabel = xAxisLabels && xAxisLabels.questions && xAxisLabels.questions.join(" ");
  var yAxisLabel = yAxisLabels && yAxisLabels.questions && yAxisLabels.questions.join(" ");
  var xAxisHeading = xAxisLabels && xAxisLabels.heading;
  var yAxisHeading = yAxisLabels && yAxisLabels.heading;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domain: {
      x: [0, 100],
      y: [0, 100]
    },
    padding: {
      left: 90,
      bottom: 90,
      right: 27,
      top: 27
    },
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryScatter, {
    data: data[0],
    style: {
      data: scatterDataStyles$1.current,
      labels: {
        fill: darkColors$1[0],
        fontFamily: fontFamily$1,
        fontSize: 12
      }
    },
    labels: function labels(_ref4) {
      var datum = _ref4.datum;
      return "Number of Respondents:\n" + datum.z;
    },
    labelComponent: React__default.createElement(HoverLabel, null)
  }), data[1] && React__default.createElement(victory.VictoryScatter, {
    data: data[1],
    style: {
      data: scatterDataStyles$1.previous
    }
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 + 45,
    y: height * 15 / 100 - 20,
    style: styles$1.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 * 3 + 25,
    y: height * 15 / 100 - 20,
    style: styles$1.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 + 45,
    y: height * 85 / 100 - 25,
    style: styles$1.quadrantLabels(matches)
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 4 * 3 + 25,
    y: height * 85 / 100 - 25,
    style: styles$1.quadrantLabels(matches)
  }), overlay && React__default.createElement(victory.VictoryArea, {
    style: {
      data: {
        fill: "rgba(0, 0, 0, 0.7)"
      }
    },
    data: [{
      x: 0,
      y: 100
    }, {
      x: 100,
      y: 100
    }]
  }), React__default.createElement(victory.VictoryAxis, {
    tickValues: styles$1.tickValues,
    tickFormat: styles$1.tickFormat,
    style: overlay ? _extends({}, styles$1.axes, {
      grid: styles$1.axes.gridOverlay
    }) : styles$1.axes,
    standalone: false
  }), !!xAxisHeading && React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(xAxisHeading, 100) || "",
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 2 + 35,
    y: height * 89 / 100,
    style: _extends({}, styles$1.labels, {
      fill: darkColors$1[0],
      fontSize: 15
    })
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(xAxisLabel || "", 100),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width / 2 + 35,
    y: height * 97 / 100 - determineXAxisLabelDisplacement$1(noOfXAxisLabels, xAxisHeading),
    style: styles$1.labels
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$1.tickValues,
    tickFormat: styles$1.tickFormat,
    style: overlay ? _extends({}, styles$1.axes, {
      grid: styles$1.axes.gridOverlay
    }) : styles$1.axes,
    standalone: false
  }), !!yAxisHeading && React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(yAxisHeading, noOfYAxisLabels > 1 ? 60 : 50),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: noOfYAxisLabels > 1 ? 20 : 25,
    y: height / 2 - 30,
    style: _extends({}, styles$1.labels, {
      fill: darkColors$1[0],
      fontSize: 15
    }),
    angle: 270
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(yAxisLabel || "", noOfYAxisLabels > 1 ? 60 : 50),
    textAnchor: "middle",
    verticalAnchor: "end",
    x: determineYAxisLabelDisplacement$1(noOfYAxisLabels, yAxisHeading),
    y: height / 2 - 30,
    style: styles$1.labels,
    angle: 270
  }), overlay && React__default.createElement(React__default.Fragment, null, React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 27 / 100 + 45,
    y: height * 20 / 100 - 20,
    style: styles$1.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(quadrantLabels.topLeft.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 27 / 100 + 45,
    y: height * 25 / 100 - 20,
    style: styles$1.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.topRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 73 / 100 + 20,
    y: height * 20 / 100 - 20,
    style: styles$1.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(quadrantLabels.topRight.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 73 / 100 + 20,
    y: height * 25 / 100 - 20,
    style: styles$1.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomLeft.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 27 / 100 + 45,
    y: height * 60 / 100 - 30,
    style: styles$1.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(quadrantLabels.bottomLeft.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 27 / 100 + 45,
    y: height * 65 / 100 - 30,
    style: styles$1.quadrantLabelsWithOverlay(matches).description
  }), React__default.createElement(victory.VictoryLabel, {
    text: quadrantLabels.bottomRight.title,
    textAnchor: "middle",
    verticalAnchor: "end",
    x: width * 73 / 100 + 20,
    y: height * 60 / 100 - 30,
    style: styles$1.quadrantLabelsWithOverlay(matches).title
  }), React__default.createElement(victory.VictoryLabel, {
    text: formatMainLabels$1(quadrantLabels.bottomRight.description, 55),
    textAnchor: "middle",
    verticalAnchor: "start",
    x: width * 73 / 100 + 20,
    y: height * 65 / 100 - 30,
    style: styles$1.quadrantLabelsWithOverlay(matches).description
  })));
};

var fontFamily$2
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';
var darkColors$2 = ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"];
var styles$2 = {
  tickValuesY: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  axes: function axes(yTickLabelFontSize) {
    return {
      grid: {
        stroke: darkColors$2[6],
        strokeWidth: 1
      },
      tickLabels: {
        fontSize: yTickLabelFontSize,
        fontFamily: fontFamily$2
      },
      axis: {
        stroke: null
      }
    };
  },
  barStyles: function barStyles(barWidth) {
    return {
      data: {
        width: barWidth
      }
    };
  },
  label: function label(yAxisLabelFontSize) {
    return {
      textAnchor: "middle",
      fill: darkColors$2[2],
      verticalAnchor: "start",
      fontSize: yAxisLabelFontSize,
      fontFamily: fontFamily$2
    };
  }
};

var determineTickFormat = function determineTickFormat(data, noLegend) {
  if (noLegend) {
    return Object.keys(data);
  }

  return Object.values(data)[0].map(function (comparison) {
    return comparison.x;
  });
};

var determineLabelType = function determineLabelType(withHoverLabels) {
  if (withHoverLabels) return React__default.createElement(victory.VictoryTooltip, {
    orientation: "top",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    flyoutWidth: 60,
    flyoutHeight: 25,
    constrainToVisibleArea: true
  });
  return React__default.createElement(victory.VictoryLabel, null);
};

var generateLegendData = function generateLegendData(noDataAvailable, data, legendFontSize) {
  if (noDataAvailable) return [].concat(Object.keys(data).map(function (name) {
    return {
      name: name,
      labels: {
        fontSize: legendFontSize,
        fontFamily: fontFamily$2,
        fill: darkColors$2[2]
      }
    };
  }), [{
    name: "No Data Available",
    labels: {
      fontSize: legendFontSize,
      fontFamily: fontFamily$2,
      fill: darkColors$2[2]
    },
    symbol: {
      fill: "#E3E3E3"
    }
  }]);
  return Object.keys(data).map(function (name) {
    return {
      name: name,
      labels: {
        fontSize: legendFontSize,
        fontFamily: fontFamily$2,
        fill: darkColors$2[2]
      }
    };
  });
};

function ComparisonBarGraph(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 500 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1000 : _ref$width,
      _ref$legendPosition = _ref.legendPosition,
      legendPosition = _ref$legendPosition === void 0 ? {
    x: width * 35 / 100,
    y: height * 92 / 100
  } : _ref$legendPosition,
      _ref$xDomainPadding = _ref.xDomainPadding,
      xDomainPadding = _ref$xDomainPadding === void 0 ? 90 : _ref$xDomainPadding,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? {
    left: 80,
    bottom: 60,
    right: 15,
    top: 50
  } : _ref$padding,
      _ref$xTickLabelFontSi = _ref.xTickLabelFontSize,
      xTickLabelFontSize = _ref$xTickLabelFontSi === void 0 ? 16 : _ref$xTickLabelFontSi,
      _ref$yTickLabelFontSi = _ref.yTickLabelFontSize,
      yTickLabelFontSize = _ref$yTickLabelFontSi === void 0 ? 18 : _ref$yTickLabelFontSi,
      _ref$legendFontSize = _ref.legendFontSize,
      legendFontSize = _ref$legendFontSize === void 0 ? 18 : _ref$legendFontSize,
      noLegend = _ref.noLegend,
      data = _ref.data,
      _ref$colorScale = _ref.colorScale,
      colorScale = _ref$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref$colorScale,
      _ref$barWidth = _ref.barWidth,
      barWidth = _ref$barWidth === void 0 ? 25 : _ref$barWidth,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 35 : _ref$offset,
      noTickLabels = _ref.noTickLabels,
      _ref$yAxisLabel = _ref.yAxisLabel,
      yAxisLabel = _ref$yAxisLabel === void 0 ? "Your Average Happiness Scores" : _ref$yAxisLabel,
      _ref$yAxisLabelFontSi = _ref.yAxisLabelFontSize,
      yAxisLabelFontSize = _ref$yAxisLabelFontSi === void 0 ? 22 : _ref$yAxisLabelFontSi,
      withHoverLabels = _ref.withHoverLabels,
      noDataAvailable = _ref.noDataAvailable;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domainPadding: {
      x: xDomainPadding,
      y: 0
    },
    padding: padding,
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: determineTickFormat(data, noLegend),
    style: {
      axis: {
        stroke: null
      },
      tickLabels: {
        fontSize: xTickLabelFontSize,
        fontFamily: fontFamily$2,
        fill: noTickLabels ? "transparent" : darkColors$2[2]
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$2.tickValuesY,
    tickFormat: styles$2.tickFormat,
    style: styles$2.axes(yTickLabelFontSize)
  }), React__default.createElement(victory.VictoryLabel, {
    x: 2,
    y: height * 45 / 100,
    style: styles$2.label(yAxisLabelFontSize),
    text: yAxisLabel,
    angle: 270
  }), React__default.createElement(victory.VictoryGroup, {
    colorScale: colorScale,
    style: styles$2.barStyles(barWidth),
    offset: offset
  }, Object.values(data).map(function (comparison, index) {
    if (noDataAvailable) {
      comparison.map(function (bar) {
        if (bar.y === 0) {
          bar.zeroValue = true;
          bar.y = 40;
        }
      });
    }

    return React__default.createElement(victory.VictoryBar, {
      key: comparison.x + "-" + index.toString(),
      data: comparison,
      labels: withHoverLabels ? function (_ref2) {
        var datum = _ref2.datum;
        return datum.zeroValue ? "No Data" : datum.y + "%";
      } : null,
      labelComponent: determineLabelType(withHoverLabels),
      style: {
        data: {
          fill: function fill(_ref3) {
            var datum = _ref3.datum;
            return noDataAvailable && datum.zeroValue === true ? "#E3E3E3" : colorScale[index];
          }
        }
      }
    });
  })), !noLegend && React__default.createElement(victory.VictoryLegend, {
    orientation: "horizontal",
    colorScale: colorScale,
    x: legendPosition.x,
    y: legendPosition.y,
    data: generateLegendData(noDataAvailable, data, legendFontSize)
  }));
}

var DEFAULT_COLOURS$1 = {
  bar: ["rgba(134, 187, 216, 1)", "rgba(134, 187, 216, 0.8)", "rgba(134, 187, 216, 0.6)"],
  label: "rgba(0, 0, 0, 0.54)",
  axis: "rgba(0, 0, 0, 0.4)"
};

var defaultTickValues = function defaultTickValues(x) {
  return "" + x.toFixed(0);
};

var HoverLabel$1 = function HoverLabel(props) {
  return React__default.createElement(victory.VictoryTooltip, _extends({}, props, {
    orientation: "right",
    flyoutStyle: {
      stroke: null,
      fill: "transparent"
    },
    cornerRadius: 10,
    pointerLength: 0,
    dy: 0,
    dx: 0,
    flyoutWidth: 30,
    flyoutHeight: 30,
    constrainToVisibleArea: true
  }));
};

HoverLabel$1.defaultEvents = victory.VictoryTooltip.defaultEvents;

var HorizontalScaleBar = function HorizontalScaleBar(_ref) {
  var data = _ref.data,
      _ref$colours = _ref.colours,
      colours = _ref$colours === void 0 ? DEFAULT_COLOURS$1 : _ref$colours,
      _ref$tickFormat = _ref.tickFormat,
      tickFormat = _ref$tickFormat === void 0 ? defaultTickValues : _ref$tickFormat,
      _ref$barWidth = _ref.barWidth,
      barWidth = _ref$barWidth === void 0 ? 20 : _ref$barWidth,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 30 : _ref$padding,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 80 : _ref$height,
      withHoverLabels = _ref.withHoverLabels,
      _ref$hoverLabelFormat = _ref.hoverLabelFormat,
      hoverLabelFormat = _ref$hoverLabelFormat === void 0 ? function (_ref2) {
    var datum = _ref2.datum;
    return datum.y + "%";
  } : _ref$hoverLabelFormat,
      _ref$labelFontSize = _ref.labelFontSize,
      labelFontSize = _ref$labelFontSize === void 0 ? 12 : _ref$labelFontSize;
  return React__default.createElement(victory.VictoryChart, {
    domain: {
      x: [0, 1]
    },
    padding: padding,
    height: height
  }, React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickFormat: tickFormat,
    style: {
      axis: {
        stroke: colours.axis
      },
      tickLabels: {
        fontSize: labelFontSize,
        fill: colours.label,
        padding: 4
      }
    }
  }), React__default.createElement(victory.VictoryBar, {
    data: [{
      x: 1,
      y: data
    }],
    horizontal: true,
    barWidth: barWidth,
    labels: withHoverLabels ? hoverLabelFormat : null,
    labelComponent: withHoverLabels ? React__default.createElement(HoverLabel$1, null) : React__default.createElement(victory.VictoryLabel, null),
    style: {
      data: {
        fill: function fill(_ref3) {
          var index = _ref3.index;
          return colours.bar[index] || colours.bar[0];
        }
      },
      labels: {
        fill: colours.label,
        fontSize: 10,
        padding: -16
      }
    }
  }));
};

var CustomLabel = function CustomLabel(_ref) {
  var labelFontSize = _ref.labelFontSize,
      props = _objectWithoutPropertiesLoose(_ref, ["labelFontSize"]);

  return React__default.createElement(victory.VictoryTooltip, _extends({}, props, {
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    orientation: "bottom",
    cornerRadius: 10,
    pointerLength: 0,
    constrainToVisibleArea: true,
    style: {
      fontSize: labelFontSize,
      fill: "rgba(0, 0, 0, 0.6)"
    }
  }));
};

CustomLabel.defaultEvents = victory.VictoryTooltip.defaultEvents;

var PieChart = function PieChart(_ref2) {
  var data = _ref2.data,
      _ref2$hoverLabelForma = _ref2.hoverLabelFormat,
      hoverLabelFormat = _ref2$hoverLabelForma === void 0 ? function (_ref3) {
    var datum = _ref3.datum;
    return datum.x + ":\n" + datum.y + "%";
  } : _ref2$hoverLabelForma,
      withHoverLabels = _ref2.withHoverLabels,
      categories = _ref2.categories,
      height = _ref2.height,
      labelFontSize = _ref2.labelFontSize,
      legendFontSize = _ref2.legendFontSize,
      _ref2$flexDirection = _ref2.flexDirection,
      flexDirection = _ref2$flexDirection === void 0 ? "row" : _ref2$flexDirection,
      _ref2$legendPosition = _ref2.legendPosition,
      legendPosition = _ref2$legendPosition === void 0 ? {
    x: 0,
    y: 20
  } : _ref2$legendPosition,
      noLegend = _ref2.noLegend,
      _ref2$colorScale = _ref2.colorScale,
      colorScale = _ref2$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref2$colorScale;
  return React__default.createElement(victory.VictoryChart, {
    padding: {
      top: 10,
      bottom: 10,
      left: 50,
      right: 0
    }
  }, React__default.createElement(victory.VictoryPie, {
    data: data,
    colorScale: colorScale,
    labels: withHoverLabels ? hoverLabelFormat : null,
    labelComponent: withHoverLabels ? React__default.createElement(CustomLabel, {
      labelFontSize: labelFontSize
    }) : React__default.createElement(victory.VictoryLabel, null),
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    }),
    categories: categories,
    height: height
  }), React__default.createElement(victory.VictoryAxis, {
    style: {
      axis: {
        stroke: "none"
      },
      tickLabels: {
        fill: "none"
      }
    }
  }), !noLegend && React__default.createElement(victory.VictoryLegend, {
    y: legendPosition.y,
    x: legendPosition.x,
    orientation: flexDirection === "column" ? "horizontal" : null,
    centerTitle: true,
    title: "Legend",
    colorScale: colorScale,
    data: data.map(function (datum) {
      return {
        name: datum.x,
        labels: {
          fontSize: legendFontSize
        }
      };
    }),
    height: height,
    fontSize: labelFontSize
  }));
};

var fontFamily$3
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';
var darkColors$3 = ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"];
var styles$3 = {
  tickValuesY: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  axes: function axes(yTickLabelFontSize) {
    return {
      grid: {
        stroke: darkColors$3[6],
        strokeWidth: 1
      },
      tickLabels: {
        fontSize: yTickLabelFontSize,
        fontFamily: fontFamily$3
      },
      axis: {
        stroke: null
      }
    };
  },
  barStyles: function barStyles(barWidth) {
    return {
      data: {
        width: barWidth
      }
    };
  },
  label: function label(yAxisLabelFontSize) {
    return {
      textAnchor: "middle",
      fill: darkColors$3[2],
      verticalAnchor: "start",
      fontSize: yAxisLabelFontSize,
      fontFamily: fontFamily$3
    };
  }
};

var determineTickFormat$1 = function determineTickFormat(data) {
  return Array(Object.values(data).length).fill("");
};

var determineLabelType$1 = function determineLabelType(withHoverLabels) {
  if (withHoverLabels) return React__default.createElement(victory.VictoryTooltip, {
    orientation: "top",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    flyoutWidth: 50,
    flyoutHeight: 25,
    constrainToVisibleArea: true
  });
  return React__default.createElement(victory.VictoryLabel, null);
};

function CompareAvHappinessCBG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 500 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1000 : _ref$width,
      _ref$legendPosition = _ref.legendPosition,
      legendPosition = _ref$legendPosition === void 0 ? {
    x: width * 35 / 100,
    y: height * 92 / 100
  } : _ref$legendPosition,
      _ref$xDomainPadding = _ref.xDomainPadding,
      xDomainPadding = _ref$xDomainPadding === void 0 ? 90 : _ref$xDomainPadding,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? {
    left: 80,
    bottom: 60,
    right: 15,
    top: 50
  } : _ref$padding,
      _ref$xTickLabelFontSi = _ref.xTickLabelFontSize,
      xTickLabelFontSize = _ref$xTickLabelFontSi === void 0 ? 16 : _ref$xTickLabelFontSi,
      _ref$yTickLabelFontSi = _ref.yTickLabelFontSize,
      yTickLabelFontSize = _ref$yTickLabelFontSi === void 0 ? 18 : _ref$yTickLabelFontSi,
      _ref$legendFontSize = _ref.legendFontSize,
      legendFontSize = _ref$legendFontSize === void 0 ? 18 : _ref$legendFontSize,
      data = _ref.data,
      _ref$colorScale = _ref.colorScale,
      colorScale = _ref$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref$colorScale,
      _ref$barWidth = _ref.barWidth,
      barWidth = _ref$barWidth === void 0 ? 50 : _ref$barWidth,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 70 : _ref$offset,
      _ref$yAxisLabel = _ref.yAxisLabel,
      yAxisLabel = _ref$yAxisLabel === void 0 ? "Average Happiness Scores" : _ref$yAxisLabel,
      _ref$yAxisLabelFontSi = _ref.yAxisLabelFontSize,
      yAxisLabelFontSize = _ref$yAxisLabelFontSi === void 0 ? 21 : _ref$yAxisLabelFontSi,
      withHoverLabels = _ref.withHoverLabels;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domainPadding: {
      x: xDomainPadding,
      y: 0
    },
    padding: padding,
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: determineTickFormat$1(data),
    style: {
      axis: {
        stroke: null
      },
      tickLabels: {
        fontSize: xTickLabelFontSize,
        fontFamily: fontFamily$3,
        fill: "transparent"
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$3.tickValuesY,
    tickFormat: styles$3.tickFormat,
    style: styles$3.axes(yTickLabelFontSize)
  }), React__default.createElement(victory.VictoryLabel, {
    x: 2,
    y: height * 45 / 100,
    style: styles$3.label(yAxisLabelFontSize),
    text: yAxisLabel,
    angle: 270
  }), React__default.createElement(victory.VictoryGroup, {
    colorScale: colorScale,
    style: styles$3.barStyles(barWidth),
    offset: offset
  }, Object.entries(data).map(function (_ref2, index) {
    var section = _ref2[0],
        score = _ref2[1];
    return React__default.createElement(victory.VictoryBar, {
      key: section + "-" + index.toString(),
      data: [{
        x: "",
        y: score
      }],
      labels: withHoverLabels ? function (_ref3) {
        var datum = _ref3.datum;
        return datum.y + "%";
      } : null,
      labelComponent: determineLabelType$1(withHoverLabels)
    });
  })), React__default.createElement(victory.VictoryLegend, {
    orientation: "horizontal",
    colorScale: colorScale,
    x: legendPosition.x,
    y: legendPosition.y,
    data: ["Your Score", "Industry", "Global"].map(function (name) {
      return {
        name: name,
        labels: {
          fontSize: legendFontSize,
          fontFamily: fontFamily$3,
          fill: darkColors$3[2]
        }
      };
    })
  }));
}

// Function to wrap text to next line of long labels
var wrapLabels = function wrapLabels(text, maxWidth) {
  return text.replace(new RegExp("(?![^\\n]{1," + maxWidth + "}$)([^\\n]{1," + maxWidth + "})\\s", "g"), "$1\n");
};
var formatLabels = function formatLabels(data, wrapLabelLength) {
  return Object.entries(data).reduce(function (acc, _ref) {
    var _extends2;

    var key = _ref[0],
        value = _ref[1];
    return _extends({}, acc, (_extends2 = {}, _extends2[wrapLabels(key, wrapLabelLength)] = value.map(function (val) {
      return _extends({}, val, {
        x: wrapLabels(val.x, wrapLabelLength)
      });
    }), _extends2));
  }, {});
};
var formatLabels$1 = {
  wrapLabels: wrapLabels,
  formatLabels: formatLabels
};

var sortValues = function sortValues(values) {
  return values.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
};

var DataFormatWrapper = function DataFormatWrapper(_ref) {
  var data = _ref.data,
      type = _ref.type,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "type", "children"]);

  var formattedData;

  if (type === "breakdown") {
    formattedData = sortValues([].concat(data)).map(function (_ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      return {
        name: wrapLabels(frontendUtils.titleCaps(name), 20),
        value: value
      };
    });
  }

  if (type === "questions") {
    formattedData = data.map(function (_ref3) {
      var question = _ref3.question,
          values = _ref3.values;
      return {
        question: wrapLabels(question, 35),
        values: values
      };
    });
  }

  if (type === "six-step-comparison") {
    formattedData = data;
  }

  return children(_extends({
    data: formattedData
  }, props));
};

var fontFamily$4
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';
var darkColors$4 = ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"];
var styles$4 = {
  tickValuesY: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  axes: function axes(yTickLabelFontSize) {
    return {
      grid: {
        stroke: darkColors$4[6],
        strokeWidth: 1
      },
      tickLabels: {
        fontSize: yTickLabelFontSize,
        fontFamily: fontFamily$4
      },
      axis: {
        stroke: null
      }
    };
  },
  barStyles: function barStyles(barWidth) {
    return {
      data: {
        width: barWidth
      }
    };
  },
  label: function label(yAxisLabelFontSize) {
    return {
      textAnchor: "middle",
      fill: darkColors$4[2],
      verticalAnchor: "start",
      fontSize: yAxisLabelFontSize,
      fontFamily: fontFamily$4
    };
  }
};

var determineTickFormat$2 = function determineTickFormat(data) {
  return data.map(function (comparison) {
    return comparison.name;
  });
};

var determineLabelType$2 = function determineLabelType(withHoverLabels) {
  if (withHoverLabels) return React__default.createElement(victory.VictoryTooltip, {
    orientation: "top",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    flyoutWidth: 50,
    flyoutHeight: 25,
    constrainToVisibleArea: true
  });
  return React__default.createElement(victory.VictoryLabel, null);
};

function BaseBreakdownCBG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 500 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1000 : _ref$width,
      _ref$xDomainPadding = _ref.xDomainPadding,
      xDomainPadding = _ref$xDomainPadding === void 0 ? 150 : _ref$xDomainPadding,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? {
    left: 80,
    bottom: 60,
    right: 15,
    top: 50
  } : _ref$padding,
      _ref$xTickLabelFontSi = _ref.xTickLabelFontSize,
      xTickLabelFontSize = _ref$xTickLabelFontSi === void 0 ? 12 : _ref$xTickLabelFontSi,
      _ref$yTickLabelFontSi = _ref.yTickLabelFontSize,
      yTickLabelFontSize = _ref$yTickLabelFontSi === void 0 ? 12 : _ref$yTickLabelFontSi,
      data = _ref.data,
      _ref$colorScale = _ref.colorScale,
      colorScale = _ref$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref$colorScale,
      _ref$barWidth = _ref.barWidth,
      barWidth = _ref$barWidth === void 0 ? 35 : _ref$barWidth,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$yAxisLabel = _ref.yAxisLabel,
      yAxisLabel = _ref$yAxisLabel === void 0 ? "Average Happiness Scores" : _ref$yAxisLabel,
      _ref$yAxisLabelFontSi = _ref.yAxisLabelFontSize,
      yAxisLabelFontSize = _ref$yAxisLabelFontSi === void 0 ? 16 : _ref$yAxisLabelFontSi,
      withHoverLabels = _ref.withHoverLabels;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domainPadding: {
      x: xDomainPadding,
      y: 0
    },
    padding: padding,
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: determineTickFormat$2(data),
    style: {
      axis: {
        stroke: null
      },
      tickLabels: {
        fontSize: xTickLabelFontSize,
        fontFamily: fontFamily$4,
        fill: darkColors$4[2]
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$4.tickValuesY,
    tickFormat: styles$4.tickFormat,
    style: styles$4.axes(yTickLabelFontSize)
  }), React__default.createElement(victory.VictoryLabel, {
    x: 2,
    y: height * 45 / 100,
    style: styles$4.label(yAxisLabelFontSize),
    text: yAxisLabel,
    angle: 270
  }), React__default.createElement(victory.VictoryGroup, {
    colorScale: colorScale,
    style: styles$4.barStyles(barWidth),
    offset: offset
  }, data.map(function (_ref2, index) {
    var name = _ref2.name,
        value = _ref2.value;
    return React__default.createElement(victory.VictoryBar, {
      key: name + "-" + index.toString(),
      data: [{
        x: name,
        y: value
      }],
      labels: withHoverLabels ? function (_ref3) {
        var datum = _ref3.datum;
        return datum.y + "%";
      } : null,
      labelComponent: determineLabelType$2(withHoverLabels)
    });
  })));
}

var BreakdownCBG = function BreakdownCBG(props) {
  return React__default.createElement(DataFormatWrapper, _extends({
    type: "breakdown"
  }, props), function (_ref) {
    var data = _ref.data,
        rest = _objectWithoutPropertiesLoose(_ref, ["data"]);

    return React__default.createElement(BaseBreakdownCBG, _extends({
      data: data
    }, rest));
  });
};

var fontFamily$5
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';
var darkColors$5 = ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"];
var styles$5 = {
  tickValuesY: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  axes: function axes(yTickLabelFontSize) {
    return {
      grid: {
        stroke: darkColors$5[6],
        strokeWidth: 1
      },
      tickLabels: {
        fontSize: yTickLabelFontSize,
        fontFamily: fontFamily$5
      },
      axis: {
        stroke: null
      }
    };
  },
  barStyles: function barStyles(barWidth) {
    return {
      data: {
        width: barWidth
      }
    };
  },
  label: function label(yAxisLabelFontSize) {
    return {
      textAnchor: "middle",
      fill: darkColors$5[2],
      verticalAnchor: "start",
      fontSize: yAxisLabelFontSize,
      fontFamily: fontFamily$5
    };
  }
};

var determineTickFormat$3 = function determineTickFormat(data) {
  return data.map(function (_ref) {
    var question = _ref.question;
    return question;
  });
};

var determineLabelType$3 = function determineLabelType(withHoverLabels) {
  if (withHoverLabels) return React__default.createElement(victory.VictoryTooltip, {
    orientation: "top",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    flyoutWidth: 50,
    flyoutHeight: 25,
    constrainToVisibleArea: true
  });
  return React__default.createElement(victory.VictoryLabel, null);
};

function BaseQuestionComparisonCBG(_ref2) {
  var _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 500 : _ref2$height,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 1000 : _ref2$width,
      _ref2$legendPosition = _ref2.legendPosition,
      legendPosition = _ref2$legendPosition === void 0 ? {
    x: width * 35 / 100,
    y: height * 92 / 100
  } : _ref2$legendPosition,
      _ref2$xDomainPadding = _ref2.xDomainPadding,
      xDomainPadding = _ref2$xDomainPadding === void 0 ? 90 : _ref2$xDomainPadding,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? {
    left: 80,
    bottom: 60,
    right: 15,
    top: 50
  } : _ref2$padding,
      _ref2$xTickLabelFontS = _ref2.xTickLabelFontSize,
      xTickLabelFontSize = _ref2$xTickLabelFontS === void 0 ? 12 : _ref2$xTickLabelFontS,
      _ref2$yTickLabelFontS = _ref2.yTickLabelFontSize,
      yTickLabelFontSize = _ref2$yTickLabelFontS === void 0 ? 12 : _ref2$yTickLabelFontS,
      _ref2$legendFontSize = _ref2.legendFontSize,
      legendFontSize = _ref2$legendFontSize === void 0 ? 16 : _ref2$legendFontSize,
      data = _ref2.data,
      _ref2$colorScale = _ref2.colorScale,
      colorScale = _ref2$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref2$colorScale,
      _ref2$barWidth = _ref2.barWidth,
      barWidth = _ref2$barWidth === void 0 ? 25 : _ref2$barWidth,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 35 : _ref2$offset,
      noTickLabels = _ref2.noTickLabels,
      _ref2$yAxisLabel = _ref2.yAxisLabel,
      yAxisLabel = _ref2$yAxisLabel === void 0 ? "Average Happiness Scores" : _ref2$yAxisLabel,
      _ref2$yAxisLabelFontS = _ref2.yAxisLabelFontSize,
      yAxisLabelFontSize = _ref2$yAxisLabelFontS === void 0 ? 16 : _ref2$yAxisLabelFontS,
      withHoverLabels = _ref2.withHoverLabels;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domainPadding: {
      x: xDomainPadding,
      y: 0
    },
    padding: padding,
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: determineTickFormat$3(data),
    style: {
      axis: {
        stroke: null
      },
      tickLabels: {
        fontSize: xTickLabelFontSize,
        fontFamily: fontFamily$5,
        fill: noTickLabels ? "transparent" : darkColors$5[2]
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$5.tickValuesY,
    tickFormat: styles$5.tickFormat,
    style: styles$5.axes(yTickLabelFontSize)
  }), React__default.createElement(victory.VictoryLabel, {
    x: 2,
    y: height * 45 / 100,
    style: styles$5.label(yAxisLabelFontSize),
    text: yAxisLabel,
    angle: 270
  }), React__default.createElement(victory.VictoryGroup, {
    colorScale: colorScale,
    style: styles$5.barStyles(barWidth),
    offset: offset
  }, data.reduce(function (acc, _ref3) {
    var question = _ref3.question,
        values = _ref3.values;
    acc[0].push({
      x: question,
      y: values.score
    });
    acc[1].push({
      x: question,
      y: values.industry
    });
    acc[2].push({
      x: question,
      y: values.global
    });
    return acc;
  }, [[], [], []]).map(function (comparisons, index) {
    return React__default.createElement(victory.VictoryBar, {
      key: comparisons + "-" + index.toString(),
      data: comparisons,
      labels: withHoverLabels ? function (_ref4) {
        var datum = _ref4.datum;
        return datum.y + "%";
      } : null,
      labelComponent: determineLabelType$3(withHoverLabels)
    });
  })), React__default.createElement(victory.VictoryLegend, {
    orientation: "horizontal",
    colorScale: colorScale,
    x: legendPosition.x,
    y: legendPosition.y,
    data: ["Your Score", "Industry", "Global"].map(function (name) {
      return {
        name: name,
        labels: {
          fontSize: legendFontSize,
          fontFamily: fontFamily$5,
          fill: darkColors$5[2]
        }
      };
    })
  }));
}

var QuestionComparisonCBG = function QuestionComparisonCBG(props) {
  return React__default.createElement(DataFormatWrapper, _extends({
    type: "questions"
  }, props), function (_ref) {
    var data = _ref.data,
        rest = _objectWithoutPropertiesLoose(_ref, ["data"]);

    return React__default.createElement(BaseQuestionComparisonCBG, _extends({
      data: data
    }, rest));
  });
};

var fontFamily$6
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';
var darkColors$6 = ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"];
var styles$6 = {
  tickValuesY: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  tickFormat: function tickFormat(t) {
    return t % 100 === 0 ? t + "%" : t;
  },
  // add '%' symbol on ticks
  axes: function axes(yTickLabelFontSize) {
    return {
      grid: {
        stroke: darkColors$6[6],
        strokeWidth: 1
      },
      tickLabels: {
        fontSize: yTickLabelFontSize,
        fontFamily: fontFamily$6
      },
      axis: {
        stroke: null
      }
    };
  },
  barStyles: function barStyles(barWidth) {
    return {
      data: {
        width: barWidth
      }
    };
  },
  label: function label(yAxisLabelFontSize) {
    return {
      textAnchor: "middle",
      fill: darkColors$6[2],
      verticalAnchor: "start",
      fontSize: yAxisLabelFontSize,
      fontFamily: fontFamily$6
    };
  }
};

var determineTickFormat$4 = function determineTickFormat(data) {
  return data.map(function (_ref) {
    var name = _ref.name;
    return name;
  });
};

var determineLabelType$4 = function determineLabelType(withHoverLabels) {
  if (withHoverLabels) return React__default.createElement(victory.VictoryTooltip, {
    orientation: "top",
    flyoutStyle: {
      stroke: null,
      fill: "#e3e3e3"
    },
    cornerRadius: 10,
    pointerLength: 0,
    flyoutWidth: 50,
    flyoutHeight: 25,
    constrainToVisibleArea: true
  });
  return React__default.createElement(victory.VictoryLabel, null);
};

function BaseQuestionComparisonCBG$1(_ref2) {
  var _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 500 : _ref2$height,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 1000 : _ref2$width,
      _ref2$legendPosition = _ref2.legendPosition,
      legendPosition = _ref2$legendPosition === void 0 ? {
    x: width * 35 / 100,
    y: height * 92 / 100
  } : _ref2$legendPosition,
      _ref2$xDomainPadding = _ref2.xDomainPadding,
      xDomainPadding = _ref2$xDomainPadding === void 0 ? 90 : _ref2$xDomainPadding,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? {
    left: 80,
    bottom: 60,
    right: 15,
    top: 50
  } : _ref2$padding,
      _ref2$xTickLabelFontS = _ref2.xTickLabelFontSize,
      xTickLabelFontSize = _ref2$xTickLabelFontS === void 0 ? 14 : _ref2$xTickLabelFontS,
      _ref2$yTickLabelFontS = _ref2.yTickLabelFontSize,
      yTickLabelFontSize = _ref2$yTickLabelFontS === void 0 ? 14 : _ref2$yTickLabelFontS,
      _ref2$legendFontSize = _ref2.legendFontSize,
      legendFontSize = _ref2$legendFontSize === void 0 ? 16 : _ref2$legendFontSize,
      data = _ref2.data,
      _ref2$colorScale = _ref2.colorScale,
      colorScale = _ref2$colorScale === void 0 ? ["#86BBD8", "#33658A", "#2F4858", "#6E9AB1", "#CCE1EB", "#5C94BE", "#6BBDE8", "#D1EFFF", "#A3DFFF", "#223440"] : _ref2$colorScale,
      _ref2$barWidth = _ref2.barWidth,
      barWidth = _ref2$barWidth === void 0 ? 25 : _ref2$barWidth,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 32 : _ref2$offset,
      noTickLabels = _ref2.noTickLabels,
      _ref2$yAxisLabel = _ref2.yAxisLabel,
      yAxisLabel = _ref2$yAxisLabel === void 0 ? "Average Happiness Scores" : _ref2$yAxisLabel,
      _ref2$yAxisLabelFontS = _ref2.yAxisLabelFontSize,
      yAxisLabelFontSize = _ref2$yAxisLabelFontS === void 0 ? 18 : _ref2$yAxisLabelFontS,
      withHoverLabels = _ref2.withHoverLabels;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    domainPadding: {
      x: xDomainPadding,
      y: 0
    },
    padding: padding,
    containerComponent: React__default.createElement(victory.VictoryContainer, {
      style: {
        touchAction: "auto"
      }
    })
  }, React__default.createElement(victory.VictoryAxis, {
    tickFormat: determineTickFormat$4(data),
    style: {
      axis: {
        stroke: null
      },
      tickLabels: {
        fontSize: xTickLabelFontSize,
        fontFamily: fontFamily$6,
        fill: noTickLabels ? "transparent" : darkColors$6[2]
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    dependentAxis: true,
    tickValues: styles$6.tickValuesY,
    tickFormat: styles$6.tickFormat,
    style: styles$6.axes(yTickLabelFontSize)
  }), React__default.createElement(victory.VictoryLabel, {
    x: 2,
    y: height * 45 / 100,
    style: styles$6.label(yAxisLabelFontSize),
    text: yAxisLabel,
    angle: 270
  }), React__default.createElement(victory.VictoryGroup, {
    colorScale: colorScale,
    style: styles$6.barStyles(barWidth),
    offset: offset
  }, data.reduce(function (acc, _ref3) {
    var name = _ref3.name,
        score = _ref3.score,
        global = _ref3.global,
        industry = _ref3.industry;
    acc[0].push({
      x: name,
      y: score
    });
    acc[1].push({
      x: name,
      y: industry
    });
    acc[2].push({
      x: name,
      y: global
    });
    return acc;
  }, [[], [], []]).map(function (comparisons, index) {
    return React__default.createElement(victory.VictoryBar, {
      key: comparisons + "-" + index.toString(),
      data: comparisons,
      labels: withHoverLabels ? function (_ref4) {
        var datum = _ref4.datum;
        return datum.y + "%";
      } : null,
      labelComponent: determineLabelType$4(withHoverLabels)
    });
  })), React__default.createElement(victory.VictoryLegend, {
    orientation: "horizontal",
    colorScale: colorScale,
    x: legendPosition.x,
    y: legendPosition.y,
    data: ["Your Score", "Industry", "Global"].map(function (name) {
      return {
        name: name,
        labels: {
          fontSize: legendFontSize,
          fontFamily: fontFamily$6,
          fill: darkColors$6[2]
        }
      };
    })
  }));
}

var SixStepComparisonCBG = function SixStepComparisonCBG(props) {
  return React__default.createElement(DataFormatWrapper, _extends({
    type: "six-step-comparison"
  }, props), function (_ref) {
    var data = _ref.data,
        rest = _objectWithoutPropertiesLoose(_ref, ["data"]);

    return React__default.createElement(BaseQuestionComparisonCBG$1, _extends({
      data: data
    }, rest));
  });
};

var fontFamily$7
/* eslint-disable-next-line quotes */
= '"Roboto", "Gill Sans MT", "Seravek", "Trebuchet MS", sans-serif';

var LineGraph = function LineGraph(_ref) {
  var data = _ref.data,
      _ref$interpolation = _ref.interpolation,
      interpolation = _ref$interpolation === void 0 ? "linear" : _ref$interpolation,
      height = _ref.height,
      width = _ref.width,
      _ref$lineStrokeColour = _ref.lineStrokeColour,
      lineStrokeColour = _ref$lineStrokeColour === void 0 ? "#5AEEB8" : _ref$lineStrokeColour,
      _ref$labelColour = _ref.labelColour,
      labelColour = _ref$labelColour === void 0 ? "#00000089" : _ref$labelColour,
      _ref$axisColour = _ref.axisColour,
      axisColour = _ref$axisColour === void 0 ? "#0000001E" : _ref$axisColour,
      _ref$axisLabelFontSiz = _ref.axisLabelFontSize,
      axisLabelFontSize = _ref$axisLabelFontSiz === void 0 ? 12 : _ref$axisLabelFontSiz,
      _ref$AxisTickFontSize = _ref.AxisTickFontSize,
      AxisTickFontSize = _ref$AxisTickFontSize === void 0 ? 12 : _ref$AxisTickFontSize,
      yAxisLabel = _ref.yAxisLabel,
      xAxisLabel = _ref.xAxisLabel,
      _ref$yAxisLabelDistan = _ref.yAxisLabelDistance,
      yAxisLabelDistance = _ref$yAxisLabelDistan === void 0 ? 0 : _ref$yAxisLabelDistan,
      _ref$xAxisLabelDistan = _ref.xAxisLabelDistance,
      xAxisLabelDistance = _ref$xAxisLabelDistan === void 0 ? 36 : _ref$xAxisLabelDistan,
      _ref$yAxisTickDistanc = _ref.yAxisTickDistance,
      yAxisTickDistance = _ref$yAxisTickDistanc === void 0 ? 5 : _ref$yAxisTickDistanc,
      _ref$xAxisTickDistanc = _ref.xAxisTickDistance,
      xAxisTickDistance = _ref$xAxisTickDistanc === void 0 ? -20 : _ref$xAxisTickDistanc,
      _ref$domainPadding = _ref.domainPadding,
      domainPadding = _ref$domainPadding === void 0 ? 10 : _ref$domainPadding,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? {
    top: 10,
    bottom: 80,
    left: 50,
    right: 10
  } : _ref$padding;
  return React__default.createElement(victory.VictoryChart, {
    width: width,
    height: height,
    padding: padding,
    domainPadding: domainPadding,
    containerComponent: React__default.createElement(victory.VictoryVoronoiContainer, {
      labels: function labels(datum) {
        return /line/.test(datum.datum.childName) ? datum.datum.x : null;
      },
      labelComponent: React__default.createElement(victory.VictoryTooltip, {
        dy: -7,
        constrainToVisibleArea: true,
        flyoutStyle: {
          strokeWidth: 0
        },
        style: {
          fontSize: AxisTickFontSize
        }
      })
    })
  }, React__default.createElement(victory.VictoryAxis, {
    label: xAxisLabel,
    axisLabelComponent: React__default.createElement(victory.VictoryLabel, {
      dy: xAxisLabelDistance
    }),
    tickLabelComponent: React__default.createElement(victory.VictoryLabel, {
      dx: xAxisTickDistance
    }),
    style: {
      tickLabels: {
        angle: -90,
        fontFamily: fontFamily$7,
        fontSize: AxisTickFontSize,
        fill: labelColour,
        opacity: function opacity() {
          return data.length === 0 ? 0 : 1;
        }
      },
      axisLabel: {
        fontSize: axisLabelFontSize,
        fill: labelColour,
        fontFamily: fontFamily$7
      },
      axis: {
        stroke: axisColour
      }
    }
  }), React__default.createElement(victory.VictoryAxis, {
    label: yAxisLabel,
    axisLabelComponent: React__default.createElement(victory.VictoryLabel, {
      dy: yAxisLabelDistance
    }),
    tickLabelComponent: React__default.createElement(victory.VictoryLabel, {
      dx: yAxisTickDistance
    }),
    style: {
      tickLabels: {
        fontSize: AxisTickFontSize,
        fill: labelColour,
        fontFamily: fontFamily$7
      },
      axisLabel: {
        fontSize: axisLabelFontSize,
        fill: labelColour,
        fontFamily: fontFamily$7
      },
      axis: {
        stroke: axisColour
      }
    },
    dependentAxis: true,
    tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    tickFormat: function tickFormat(t) {
      return t % 100 === 0 ? t + "%" : t;
    }
  }), React__default.createElement(victory.VictoryGroup, {
    data: data
  }, React__default.createElement(victory.VictoryLine, {
    interpolation: interpolation,
    domain: {
      y: [0, 100]
    },
    style: {
      data: {
        stroke: lineStrokeColour
      }
    }
  }), React__default.createElement(victory.VictoryScatter, {
    size: 5,
    style: {
      data: {
        fill: lineStrokeColour
      }
    }
  })));
};

exports.BreakdownCBG = BreakdownCBG;
exports.CircularProgress = CircularProgress;
exports.ComparisonBarGraph = ComparisonBarGraph;
exports.FormatLabels = formatLabels$1;
exports.HappinessCBG = CompareAvHappinessCBG;
exports.HorizontalScaleBar = HorizontalScaleBar;
exports.LineGraph = LineGraph;
exports.OrganisationMatrix = OrganisationMatrix;
exports.PercentageBar = PercentageBar;
exports.PieChart = PieChart;
exports.QuestionCBG = QuestionComparisonCBG;
exports.ResultsMatrix = ResultsMatrix;
exports.SixStepComparisonCBG = SixStepComparisonCBG;
